module.exports = __webpack_public_path__ + "img/reset_blue.25bb4fa4.svg";